@if (token.valid && !resetPasswordResult) {
  <div class="blk-cont">
    <div class="blk-header">
      <span class="blk-title" i18n>Password Reset</span>
      <div class="blk-icon">
        <tui-icon [icon]="'mat::unlock'"></tui-icon>
      </div>
    </div>
    <div class="blk-body">
      <form
        [formGroup]="passwordForm"
        #passwordFormControl="ngForm"
        (ngSubmit)="resetPassword()"
        class="w-100">
        <div class="row my-2">
          <div class="col-12 text-center">
            <tui-input-password
              #passControl
              [tuiHintAppearance]="
                ([] | tuiFieldErrorContent) ? 'error' : 'default'
              "
              [tuiHint]="[] | tuiFieldErrorContent"
              [tuiTextfieldCustomContent]="
                passControl.touched
                  ? passControl.valid
                    ? fcsuccess
                    : fcerror
                  : ''
              "
              formControlName="passValue"
              tuiTextfieldSize="l">
              <ng-container i18n>Password</ng-container>
              <input tuiTextfieldLegacy />
            </tui-input-password>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <tui-input-password
              #repassControl
              [tuiHintAppearance]="
                ([] | tuiFieldErrorContent) ? 'error' : 'default'
              "
              [tuiHint]="[] | tuiFieldErrorContent"
              [tuiTextfieldCustomContent]="
                repassControl.touched
                  ? repassControl.valid
                    ? fcsuccess
                    : fcerror
                  : ''
              "
              formControlName="repassValue"
              tuiTextfieldSize="l">
              <ng-container i18n>Confirm Password</ng-container>
              <input tuiTextfieldLegacy />
            </tui-input-password>
            <div class="row my-4">
              <div
                class="col-12 d-flex justify-content-between align-items-center">
                <button
                  type="button"
                  class="mbtn secondary-500 me-2"
                  [routerLink]="'/'">
                  <tui-icon [icon]="'mat::arrow_back'"></tui-icon>
                  <ng-container i18n>Cancel</ng-container>
                </button>
                <button
                  type="submit"
                  [disabled]="passwordFormControl.invalid"
                  class="mbtn primary-500 ms-3">
                  <tui-icon [icon]="'mat::lock'"></tui-icon>
                  <ng-container i18n>Change Password</ng-container>
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
} @else {
  @if (!token.token) {
    @if (sendEmailResult) {
      <div class="blk-cont small success">
        <div class="blk-header mb-4">
          <span class="blk-title" i18n>Success</span>
          <div class="blk-icon norotate success">
            <tui-icon [icon]="'mat::success'"></tui-icon>
          </div>
        </div>
        <div class="blk-body">
          <div
            class="d-flex flex-column align-items-center justify-content-start">
            <div i18n>Email instructions have been sent to</div>
            <div class="email">
              {{ emailForm.controls.emailValue.value }}
            </div>
            <div i18n class="mt-4 mx-4">
              Check your Inbox and Spam folder for further instructions
            </div>
          </div>
        </div>
      </div>
    } @else {
      <div class="blk-cont">
        <div class="blk-header">
          <span class="blk-title" style="margin: 10px" i18n
            >Password Reset</span
          >
          <div class="blk-icon">
            <tui-icon [icon]="'mat::unlock'"></tui-icon>
          </div>
        </div>
        <div class="blk-body">
          <form
            [formGroup]="emailForm"
            #emailFormControl="ngForm"
            (ngSubmit)="sendToken()"
            class="w-100">
            <div class="row my-2">
              <div class="col-12 text-center">
                <tui-input
                  i18n
                  formControlName="emailValue"
                  tuiTextfieldSize="l"
                  [tuiTextfieldLabelOutside]="true"
                  [tuiHintAppearance]="
                    ([] | tuiFieldErrorContent) ? 'error' : 'default'
                  "
                  [tuiHint]="[] | tuiFieldErrorContent"
                  name="email">
                  Your email
                  <input tuiTextfieldLegacy type="email" />
                </tui-input>
              </div>
            </div>
            <div class="row my-4">
              <div class="col-12 d-flex justify-content-end align-items-center">
                <button
                  type="button"
                  class="mbtn secondary-500 me-2"
                  [routerLink]="'/'">
                  <tui-icon [icon]="'mat::arrow_back'"></tui-icon>
                  <ng-container i18n>Back</ng-container>
                </button>
                <button
                  type="submit"
                  [disabled]="emailFormControl.invalid"
                  class="mbtn primary-500 ms-3">
                  <tui-icon [icon]="'mat::send'"></tui-icon>
                  <ng-container i18n>Send Email Instructions</ng-container>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    }
  }
}

@if (resetPasswordResult) {
  <div class="blk-cont small success">
    <div class="blk-header">
      <span class="blk-title" i18n>Success</span>
      <div class="blk-icon norotate success">
        <tui-icon [icon]="'mat::success'"></tui-icon>
      </div>
    </div>
    <div class="blk-body">
      <div
        i18n
        class="d-flex flex-column align-items-end justify-content-start">
        <div class="col-12">
          <div class="row mx-2 mb-2">
            Your password has been changed. You may go back to home page for
            login.
          </div>
        </div>
        <button
          type="button"
          class="mbtn secondary-500 me-2"
          [routerLink]="'/'">
          <tui-icon [icon]="'mat::arrow_back'"></tui-icon>
          <ng-container>Home</ng-container>
        </button>
      </div>
    </div>
  </div>
}

<ng-template #fcsuccess>
  <tui-icon [icon]="'@tui.check'" class="f-success tui-space_left-3"></tui-icon>
</ng-template>
<ng-template #fcerror>
  <tui-icon
    [icon]="'@tui.circle-alert'"
    class="f-error tui-space_left-3"></tui-icon>
</ng-template>
